export const DEFAULT_PREVIEW_DURATION = 10000;

export const DATA_TEST_IDS = {
  POSTER: 'media_preview_poster',
  TRIGGER: 'media_preview_trigger',
  EXTENSION: 'media_preview_extension',
  MODAL: 'media_preview_modal',
  IMAGE: 'media_preview_image',
  CLOSE: 'media_preview_close',
};
